import { Controller } from "@hotwired/stimulus";
import { attachTooltip } from "../lib/bubble";

/**
 * L'infobulle d'un élément (lib/bubble) : au survol ou au focus, après un court délai.
 *
 * Usage :
 *   <span data-controller="tooltip" data-tooltip-text-value="Supprimer"
 *         data-tooltip-placement-value="bottom">…</span>
 * Contenu riche : un <template data-tooltip-target="content"> à la place du texte.
 */
export default class extends Controller {
  static values = { text: String, placement: { type: String, default: "top" } };
  static targets = ["content"];

  connect() {
    this.detach = attachTooltip(this.element, {
      text: this.textValue,
      content: this.hasContentTarget ? this.contentTarget.content : undefined,
      placement: this.placementValue,
    });
  }

  disconnect() {
    this.detach?.();
  }
}
